import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  updateFilters,
  fetchSuccess,
  alertAlertCountSuccess,
  fetchFailure,
  downloadSuccess,
  downloadFailure,
  alertTypes,
  bulkUpdateResponse,
  bulkUpdateFilterSuccess,
  bulkUpdateFilterFailure,
  alertAlertStatusCountSuccess,
} from "../actions/alerts";
import {
  fetchSmartAlertsEndPoint,
  fetchLocationEndPoint,
  bulkUpdateSmartAlertEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";

function* fetchAlertSaga(action) {
  if(!sessionStorage.getItem("accountId")) return;
  const filters = action.payload;
  const levels = yield select((state) => state.alert.data.levels);

  function checkLabel(selectedLabel) {
    return filters.level[selectedLabel] === true;
  }
  try {
    yield put(updateFilters(filters));
    const alertResponse = yield call(fetchAlertAPI, filters);
    const alerts = alertResponse?.data || [];

    yield put(
      alertAlertCountSuccess({
        total: alertResponse["Total alert severity"] ?? 0,
        critical: alertResponse["Critical"] ?? 0,
        warning: alertResponse["Warning"] ?? 0,
        notification: alertResponse["Notification"] ?? 0,
        error:
          (alertResponse["Critical"] ?? 0) + (alertResponse["Error"] ?? 0),
      })
    );

    yield put(
      alertAlertStatusCountSuccess({
        total: alertResponse["Total alert status"] ?? 0,
        new: alertResponse["New"] ?? 0,
        acknowledged: alertResponse["Acknowledged"] ?? 0,
        resolved: alertResponse["Resolved"] ?? 0,
        autoresolved: alertResponse["Auto Resolved"] ?? 0,
      })
    );
    const uniqueDevices = new Set();
    const uniqueLocations = [];
    const uniqueOrganizations = [];

    for (const alert of alerts) {
      const meta = alert?.metadata || {};

      if (meta["device-name"]) uniqueDevices.add(meta["device-name"]);

      if (
        meta?.locationName &&
        !uniqueLocations.some((l) => l.value === meta.locationName)
      ) {
        uniqueLocations.push({
          id: meta.siteId,
          value: meta.locationName,
        });
      }

      if (
        meta?.organizationName &&
        !uniqueOrganizations.some((o) => o.value === meta.organizationName)
      ) {
        uniqueOrganizations.push({
          id: meta.orgId,
          value: meta.organizationName,
        });
      }
    }

    yield put(
      fetchSuccess({
        list: {
          levels: levels.map((level) => ({
            ...level,
            value: checkLabel(level.label),
          })),
          statuses: filters.status,
          alerts,
          devices: [...uniqueDevices],
          locations: uniqueLocations,
          organizations: uniqueOrganizations,
        },
        bulkUpdate: {
          organizations: [],
          locations: [],
        },
      })
    );
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}

function alertFilterbyfilters(filters) {
  let selectionFilters = [];
  if (filters.status !== null && filters.status !== "") {
    const selectedStatuses = Object.entries(filters.status)
      .filter((status) => status[1] === true)
      .map((status) => status[0]);

    const statusQuery = [];
    filters.status.forEach((selectedStatus) => {
      if (selectedStatus.text === "New" && selectedStatus.value === true) {
        statusQuery.push(
          `(isacknowledged eq 'false') AND (iscleared eq 'false') AND (state eq null)`
        );
      }
      if (
        selectedStatus.text === "Acknowledged" &&
        selectedStatus.value === true
      ) {
        statusQuery.push(`(isacknowledged eq 'true') AND (iscleared eq 'false') AND (state eq null)`);
      }

      if (selectedStatus.text === "Resolved" && selectedStatus.value === true) {
        statusQuery.push(`(iscleared eq 'true') AND (state eq null)`);
      }
      if (
        selectedStatus.text === "Auto Resolved" &&
        selectedStatus.value === true
      ) {
        statusQuery.push(`(state eq 'SYSTEM_NEW_CONDITION_CLEARED')`);
      }
    });
    if (statusQuery?.length > 0) {
      selectionFilters.push(`(${statusQuery.join(" OR ")})`);
    }
    }

  if (filters?.level !== null && filters?.level !== "") {
    const selectedlevels = Object.entries(filters.level)
      .filter((level) => level[1] === true)
      .map((level) => level[0]);

    const levelsQuery = [];
    if (selectedlevels.length > 0) {
      selectedlevels.forEach((selectedlev) => {
        if (selectedlev?.toLowerCase() === "critical") {
          levelsQuery.push(`(severity LIKE 'Critical')`);
        } else if (selectedlev?.toLowerCase() === "warning") {
          levelsQuery.push(`((severity LIKE 'Warning') OR (severity LIKE 'Major'))`);
        } else if (selectedlev.toLowerCase() === "alert") {
          levelsQuery.push(`(severity LIKE 'Alert')`);
        } else if (selectedlev.toLowerCase() === "notification") {
          levelsQuery.push(`((severity LIKE 'Notification') OR (severity LIKE 'Minor'))`);
           }
      });
    }

    if (levelsQuery.length > 0) {
      selectionFilters.push(`(${levelsQuery.join(" OR ")})`);
    }
  }
  
  // OR (description LIKE '${filters.subject}') OR ($/metadata/battery eq '${filters.subject}') OR (condition LIKE '${filters.subject}') OR ($/metadata/devicename eq '${filters.subject}
  // Rest of your filter logic remains the same
  if (filters?.subject !== null && filters?.subject !== "") {
    selectionFilters.push(
      `((name LIKE '${filters.subject}'))`
    );
  }

  if (filters?.device?.length > 0) {
    selectionFilters.push(
      `(($/metadata/device-name LIKE '${filters?.device}') OR ($/metadata/device-name eq '${filters.device}'))`
    );
  }
   function formatForSelection(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  if (filters?.lastUpdated !== null && filters?.lastUpdated !== "") {
    if (filters?.lastUpdated?.length > 0) {
    const startDate = new Date(filters?.lastUpdated[0]);
    const endDate = new Date(filters?.lastUpdated[1]);
    const startFormatted = formatForSelection(startDate);
    const endFormatted = formatForSelection(endDate);
    const filterData = [startFormatted, endFormatted].join("','");
     // const startDate = new Date(filters?.lastUpdated[0]);
     // const endDate = new Date(filters?.lastUpdated[1]);
      // const filterData = `'${startDate.getUTCFullYear()}-${
      //   (startDate.getUTCMonth() + 1).toString()
      //   .padStart(2, "0")
      // }-${startDate
      //   .getUTCDate()
      //   .toString()
      //   .padStart(2, "0")}T00:00','${endDate.getUTCFullYear()}-${(
      //   endDate.getUTCMonth() + 1
      // )
      //   .toString()
      //   .padStart(2, "0")}-${endDate
      //   .getUTCDate()
      //   .toString()
      //   .padStart(2, "0")}T23:59'`;
      selectionFilters.push(`(lastupdated between('${filterData}'))`);
    }
  }

  if (filters?.organization?.length > 0) {
    const orgFilters = filters.organization.map(
      (org) => `($/metadata/organizationName LIKE '${org}')`
    );
    const orgQuery = orgFilters.join(" OR ");
    selectionFilters.push(orgFilters.length > 1 ? `(${orgQuery})` : orgQuery);
  }

  if (filters.associationname) {
    const associationnameQuery = `(($/metadata/shipmentname LIKE '${filters.associationname}') OR ($/metadata/assetname LIKE '${filters.associationname}'))`;
    selectionFilters.push(associationnameQuery);
  }

  if (filters?.location?.length > 0) {
    const locFilters = filters.location.map(
      (loc) => `($/metadata/locationName LIKE '${loc}')`
    );
    const locQuery = locFilters.join(" OR ");
    selectionFilters.push(locFilters.length > 1 ? `(${locQuery})` : locQuery);
  }

  return selectionFilters;
}

async function fetchAlertAPI(filters) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
    filter: {
      $sort: filters.sort,
      $limitnumber: filters.limitnumber,
      $pagenumber: filters.pagenumber,
    },
  };
  const selectionFilters = alertFilterbyfilters(filters);
  if (selectionFilters.length > 0) {
    const filter = selectionFilters.join(" AND ");
    body = {
      ...body,
      filter: {
        ...body.filter,
        $selection: `${filter}`,
      },
    };
  }

  const response = await fetch(fetchSmartAlertsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) return [];

  return response.json();
}

async function fetchLocationAndOrgAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });
  if (!response.ok) throw new Error("Something Went wrong");

  const respData = await response.json();

  const organizations = respData
    .filter(
      (resp) =>
        resp?.tags &&
        resp?.tags.length > 0 &&
        resp?.tags[0]?.kind === "ts.tag.org"
    )
    .map((resp) => ({
      label: resp?.tags[0]?.org_name,
      value: resp?.tags[0]?.org_name,
    }));
  const locations = respData
    .filter(
      (resp) =>
        resp?.tags &&
        resp?.tags.length > 0 &&
        resp?.tags[0]?.kind === "ts.tag.site"
    )
    .map((resp) => ({
      label: resp?.tags[0]?.name,
      value: resp?.tags[0]?.name,
    }));

  return {
    organizations,
    locations,
  };
}

function* bulkUpdateSaga(action) {
  try {
    const bulkUpdate = yield select((state) => state.alert.bulkUpdate);
    const newData = bulkUpdate.fields;

    yield call(bulkUpdateAPI, action?.payload, newData.comment, newData.status);
    yield put(
      bulkUpdateResponse({
        isActive: true,
        message: "Bulk edit",
        description: `${action?.payload?.length} alerts ${newData.status} successfully`,
      })
    );
  } catch (error) {
    yield put(
      bulkUpdateResponse({
        type: "error",
        isActive: true,
        message: "Bulk edit",
        description: `Something went wrong`,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      })
    );
  }
}

async function bulkUpdateAPI(resourceidentifiers, comment, status) {
  let smartalert = {};

  if (status !== null && status !== "") {
    switch (status) {
      case "new":
        smartalert = {
          isacknowledged: false,
          iscleared: false,
        };
        break;
      case "acknowledged":
        smartalert = {
          isacknowledged: true,
          iscleared: false,
        };
        break;
      case "resolved":
        smartalert = {
          isacknowledged: false,
          iscleared: true,
        };
        break;
      default:
        break;
    }
  }
  const response = await fetch(bulkUpdateSmartAlertEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify({
      accountname: sessionStorage.getItem("accountId"),
      comment,
      resourceidentifiers,
      smartalert: {
        ...smartalert,
        isdisabled: null,
      },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");

  return response.json();
}

function* downloadSaga(action) {
  try {
    let response;
    if (action.payload > 500) {
      let totalPages = 0;
      if (action.payload % 500 === 0) {
        totalPages = action.payload / 500;
      } else {
        totalPages = Math.floor(action.payload / 500) + 1;
      }

      response = yield all(
        [...Array(totalPages)].map((v, i) => call(apiDownload, i))
      );
    } else {
      response = yield call(apiDownload, 0);
    }
    if (Array.isArray(response)) {
      let allData = [];
      for (const element of response) {
        allData = [...allData, element.data];
      }
      JSONToCSVDownload(CSVFormat(allData), "alerts_download.csv");
      yield put(downloadSuccess(allData));
    } else {
      JSONToCSVDownload(CSVFormat(response.data), "alerts_download.csv");
      yield put(downloadSuccess([...response]));
    }
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const CSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => {
    const batteryCriticalValue = json?.condition?.startsWith(
      "$[?(@.eventMsg.fields.battery <"
    )
      ? json.condition
          .replaceAll("$[?(@.eventMsg.fields.battery <", "")
          .replaceAll(")]", "")
          .trim()
      : "N/A";
    let acknowledged = null;
    if (!json?.state) {
      if (json.isacknowledged === false && json.iscleared === false) {
        acknowledged = "New";
      } else if (json.isacknowledged === true && json.iscleared === false) {
        acknowledged = "Acknowledge";
      } else if (json.isacknowledged === false && json.iscleared === true) {
        acknowledged = "Resolved";
      }
    } else {
      acknowledged = "Auto Resolved";
    }
    return {
      id: json.id,
      subject: `Battery Level Below ${batteryCriticalValue}%`,
      message: `Device '${json.metadata?.devicename}' has reported a battery percent level of ${json?.metadata?.battery}% which is below the critical level of ${batteryCriticalValue}%`,
      level: json.severity,
      state: acknowledged,
      deviceId: json.deviceid,
      deviceName: json.metadata?.devicename,
      organizationId: json.metadata?.orgId,
      locationId: json.metadata?.siteId,
      lastUpdated: json.lastupdated,
    };
  });
};

async function apiDownload(page_no = 0) {
  return fetch(fetchSmartAlertsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
      $pagenumber: page_no,
      $limitnumber: 500,
    }),
  }).then((response) => response.json());
}

function* bulkUpdateFilterSaga() {
  try {
    const bulkUpdate = yield select((state) => state.alert.bulkUpdate);
    const filters = bulkUpdate.filters.fields;

    let alertResponses = yield all([call(fetchAlertAPI, filters)]);

    yield put(bulkUpdateFilterSuccess(alertResponses[0].count));
  } catch (error) {
    yield put(bulkUpdateFilterFailure());
  }
}

export function* FetchAlertSaga() {
  yield takeLatest(alertTypes.FETCH_REQUEST, fetchAlertSaga);
}

export function* AlertDownloadSaga() {
  yield takeLatest(alertTypes.DOWNLOAD_REQUEST, downloadSaga);
}

export function* BulkUpdateSaga() {
  yield takeLatest(alertTypes.BULK_UPDATE_SUBMIT, bulkUpdateSaga);
}

export function* BulkUpdateFilterSaga() {
  yield takeLatest(alertTypes.BULK_UPDATE_FILTER, bulkUpdateFilterSaga);
}
